{
  "app": {
    "title": "DivvyStash",
    "titleShort": "BITH"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "allocationHistory": "Allocation History",
    "withdrawals": "Withdrawals",
    "settings": "Settings",
    "admin": "Admin",
    "adminUsers": "Users",
    "adminInvites": "Invites",
    "adminProfits": "Profits",
    "adminWithdrawals": "Withdrawals",
    "logout": "Logout"
  },
  "buttons": {
    "save": "Save",
    "cancel": "Cancel",
    "submit": "Submit",
    "close": "Close",
    "edit": "Edit",
    "delete": "Delete",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "refresh": "Refresh",
    "filter": "Filter",
    "clear": "Clear",
    "download": "Download",
    "upload": "Upload",
    "search": "Search",
    "apply": "Apply",
    "reset": "Reset"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "completed": "Completed",
    "processing": "Processing",
    "failed": "Failed",
    "success": "Success",
    "error": "Error",
    "loading": "Loading..."
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "or": "or",
    "and": "and",
    "of": "of",
    "to": "to",
    "from": "from",
    "in": "in",
    "at": "at",
    "on": "on",
    "for": "for",
    "with": "with",
    "by": "by",
    "total": "Total",
    "amount": "Amount",
    "date": "Date",
    "time": "Time",
    "email": "Email",
    "name": "Name",
    "country": "Country",
    "actions": "Actions",
    "details": "Details",
    "description": "Description",
    "notes": "Notes"
  },
  "messages": {
    "saveSuccess": "Saved successfully",
    "saveFailed": "Save failed",
    "deleteSuccess": "Deleted successfully",
    "deleteFailed": "Delete failed",
    "updateSuccess": "Updated successfully",
    "updateFailed": "Update failed",
    "loadError": "Failed to load data",
    "networkError": "Network error occurred",
    "sessionExpired": "Your session has expired. Please log in again.",
    "unauthorized": "You are not authorized to perform this action",
    "notFound": "The requested resource was not found",
    "validationError": "Please check your input and try again"
  },
  "language": {
    "label": "Language",
    "english": "English",
    "spanish": "Spanish",
    "changeSuccess": "Language changed successfully"
  }
}
